<template>
  <router-view />
</template>

<script>
export default {
  name: 'FreeDaysIndex'
}
</script>
